module.exports = __webpack_public_path__ + "static/media/praias.6a371a15.svg";